<template>
  <div class="invitation-container">
    <!-- 顶部 Tab 切换 -->
    <el-tabs v-model="activeTab" @tab-click="handleTabChange">
      <el-tab-pane label="邀请人汇总" name="summary"></el-tab-pane>
      <el-tab-pane label="邀请明细" name="records"></el-tab-pane>
    </el-tabs>

    <!-- 筛选区 -->
    <el-card class="filter-card">
      <el-form :inline="true" :model="query" size="small">
        <el-form-item v-if="activeTab === 'records'" label="邀请人手机号">
          <el-input v-model="query.inviterUsername" placeholder="输入手机号" clearable style="width:180px" />
        </el-form-item>
        <el-form-item label="门店">
          <el-select v-model="query.storeId" placeholder="全部门店" clearable style="width:160px">
            <el-option v-for="s in storeList" :key="s.id" :label="s.storename" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="activeTab === 'records'" label="奖励状态">
          <el-select v-model="query.rewardStatus" placeholder="全部" clearable style="width:120px">
            <el-option label="待购卡" :value="0" />
            <el-option label="已奖励" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="fetchData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 汇总表格 -->
    <el-card v-if="activeTab === 'summary'" class="table-card">
      <el-table :data="tableData" v-loading="loading" border stripe style="width:100%">
        <el-table-column label="邀请人手机号" prop="inviterUsername" min-width="130" />
        <el-table-column label="门店" prop="storeName" min-width="150" />
        <el-table-column label="邀请人数" prop="totalInvited" align="center" width="100">
          <template slot-scope="scope">
            <el-tag type="primary">{{ scope.row.totalInvited }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="已奖励次数" prop="rewardedCount" align="center" width="110">
          <template slot-scope="scope">
            <el-tag type="success">{{ scope.row.rewardedCount }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="首次邀请时间" prop="firstScanTime" min-width="160" />
        <el-table-column label="最近邀请时间" prop="lastScanTime" min-width="160" />
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="viewDetail(scope.row.inviterUsername)">查看明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        layout="total, prev, pager, next"
        :total="total"
        :page-size="query.pageSize"
        :current-page="query.page"
        @current-change="handlePageChange" />
    </el-card>

    <!-- 明细表格 -->
    <el-card v-if="activeTab === 'records'" class="table-card">
      <el-table :data="tableData" v-loading="loading" border stripe style="width:100%">
        <el-table-column label="邀请人" prop="inviterUsername" min-width="120" />
        <el-table-column label="被邀请人" prop="inviteeUsername" min-width="120" />
        <el-table-column label="邀请码" prop="invitationCode" min-width="140" />
        <el-table-column label="门店" prop="storeName" min-width="140" />
        <el-table-column label="扫码时间" prop="scanTime" min-width="160" />
        <el-table-column label="购卡时间" prop="purchaseTime" min-width="160" />
        <el-table-column label="购卡金额" prop="purchaseAmount" align="center" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.purchaseAmount">￥{{ scope.row.purchaseAmount }}</span>
            <span v-else style="color:#ccc">-</span>
          </template>
        </el-table-column>
        <el-table-column label="奖励状态" prop="rewardStatus" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.rewardStatus === 1 ? 'success' : 'info'">
              {{ scope.row.rewardStatus === 1 ? '已奖励' : '待购卡' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="奖励发放时间" prop="rewardTime" min-width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.rewardTime">{{ scope.row.rewardTime }}</span>
            <span v-else style="color:#ccc">-</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        layout="total, prev, pager, next"
        :total="total"
        :page-size="query.pageSize"
        :current-page="query.page"
        @current-change="handlePageChange" />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'InvitationRecords',
  data() {
    return {
      activeTab: 'summary',
      loading: false,
      tableData: [],
      total: 0,
      storeList: [],
      query: {
        inviterUsername: '',
        storeId: null,
        rewardStatus: null,
        page: 1,
        pageSize: 20
      }
    }
  },
  created() {
    this.fetchStores()
    this.fetchData()
  },
  methods: {
    async fetchStores() {
      try {
        const res = await this.$http.get('/cardIssue/stores')
        if (res.data.status === 0) this.storeList = res.data.data || []
      } catch (e) {
        console.error('获取门店列表失败', e)
      }
    },
    async fetchData() {
      this.loading = true
      try {
        const api = this.activeTab === 'summary' ? '/invitation/summary' : '/invitation/records'
        const params = {
          storeId: this.query.storeId || undefined,
          page: this.query.page,
          pageSize: this.query.pageSize
        }
        if (this.activeTab === 'records') {
          params.inviterUsername = this.query.inviterUsername || undefined
          params.rewardStatus = this.query.rewardStatus != null ? this.query.rewardStatus : undefined
        }
        const res = await this.$http.get(api, { params })
        if (res.data.status === 0) {
          this.tableData = res.data.data || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.data.message || '查询失败')
        }
      } catch (e) {
        this.$message.error('网络错误')
      } finally {
        this.loading = false
      }
    },
    handleTabChange() {
      this.query.page = 1
      this.tableData = []
      this.total = 0
      this.fetchData()
    },
    handlePageChange(page) {
      this.query.page = page
      this.fetchData()
    },
    resetQuery() {
      this.query = { inviterUsername: '', storeId: null, rewardStatus: null, page: 1, pageSize: 20 }
      this.fetchData()
    },
    viewDetail(inviterUsername) {
      this.activeTab = 'records'
      this.query.inviterUsername = inviterUsername
      this.query.page = 1
      this.fetchData()
    }
  }
}
</script>

<style scoped>
.invitation-container { padding: 20px; }
.filter-card { margin-bottom: 16px; }
.table-card { }
.pagination { margin-top: 16px; text-align: right; }
</style>
